const tipoFumoList = [
    {
        id: 10,
        descricao: 'Cigarro',
        ordem: 10,
    },
    {
        id: 20,
        descricao: 'Charuto',
        ordem: 20,
    },
    {
        id: 30,
        descricao: 'Cigarrilha',
        ordem: 30,
    },
    {
        id: 40,
        descricao: 'Maconha',
        ordem: 40,
    },
    {
        id: 50,
        descricao: 'Narguilé',
        ordem: 50,
    },
    {
        id: 60,
        descricao: 'Vape',
        ordem: 60,
    },
    {
        id: 900, // HARDCODE.idTipoFumoOutros
        descricao: 'Outros',
        ordem: 900,
    },
]

export default tipoFumoList
